<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-card>
        <b-card-header
          class="base-document-header"
        >
          <b-card-title>{{ $t('DEBTIA_PAID_INVOICES') }}</b-card-title>
          <b-card-title class="text-primary">
            <!-- <drag-links
              :parent="5"
              :side="side"
              :custom-change="customChange"
            /> -->
          </b-card-title>
        </b-card-header>
        <b-table
          v-if="invoicesData.length > 0"
          :fields="invoicesTableFields"
          :items="invoicesData"
          striped
          responsive
        >
          <template #cell(file_link)="data">
            <feather-icon
              icon="ExternalLinkIcon"
              @click="openLink(data.item.file_link)"
            />
          </template>
          <template #cell(sub_total)="data">
            {{ `${formatCurrency(data.item.sub_total, defaultCurrency)}` }}
          </template>
          <template #cell(vat_amount)="data">
            {{ `${formatCurrency(data.item.vat_amount, defaultCurrency)}` }}
          </template>
          <template #cell(total_amount)="data">
            {{ `${formatCurrency(data.item.total_amount, defaultCurrency)}` }}
          </template>
        </b-table>
        <b-alert
          v-else
          variant="warning"
          show
        >
          <div class="alert-body">
            {{ $t('DEBTIA_NO_INVOICES_MSG') }}
          </div>
        </b-alert>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BTable, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import axios from '@axios'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BCardHeader,
    BCardTitle,
    // DragLinks,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      invoicesData: [],
      caseId: this.$route.params.id,
    }
  },
  computed: {
    invoicesTableFields() {
      return [
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_id', label: i18n.t('DEBTIA_PAYMENT_ID'), tdClass: 'text-right' },
        { key: 'sub_total', label: i18n.t('DEBTIA_SUB_TOTAL'), tdClass: 'text-right' },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'total_amount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
      ]
    },
  },
  // setup() {
  //   const { invoicesData } = store.state['case-details']
  //   return {
  //     invoicesData,
  //   }
  // },
  created() {
  },
  methods: {
    async fetchInitialData() {
      await this.getInvoices()
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    async getInvoices() {
      const url = `${constants.baseUrlV2}/debt-case/invoices-data/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.invoicesData = response.data.data
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
